var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('v-card',{staticClass:"mx-auto mt-8",attrs:{"flat":""}},[_c('v-card-title',[_c('h2',{staticClass:"red--text"},[_vm._v("Elecciones")])]),_c('v-card-text',{staticClass:"pb-8"},[_c('listElections')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }